module.exports = __webpack_public_path__ + "static/media/options-icon.479d91c8.svg";